export default "__VITE_ASSET__kUSeIueW__"